import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { TailSpin } from 'react-loader-spinner';
import { RECUPERE_SOUSCRIPTION, VERFIF_SOUSCRIPTION } from '../../Utils/constant';
import { find, store } from '../../services/service';
import { ValidateMessage } from '../Widget/ValidateMessage';

export const Souscription = ({ numeroTicket, handleNext }) => {
    const [souscription, setSouscription] = useState(null)
    const [isPostPaid, setIsPostPaid] = useState(null)
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(true)
    useEffect(() => {
        store(`${VERFIF_SOUSCRIPTION}?numeroTicket=${numeroTicket}`, "application/json", {}).then((res) => {
            setIsPostPaid(res.data.donnee);
        }).catch((err) => {

        })

        if (isPostPaid === false) {
            find(`${RECUPERE_SOUSCRIPTION}?numeroTicket=${numeroTicket}`).then((res) => {
                setSouscription(res.data)
                setLoading(false)
            }).catch((err) => {
                setError(err.response.data)
                setLoading(false)
            })
        }

    }, [isPostPaid])

    return (
        <>
            {
                isPostPaid === true ? <ValidateMessage texte={"Souscription effectuée"} /> :
                    souscription != null && loading === false ?
                        <div className="p-3 rounded-lg">
                            <div className="px-4 sm:px-0">
                                <h3 className="lg:text-lg text-2xl text-gray-900">
                                    Information sur la souscription du client
                                </h3>
                            </div>
                            <div className="mt-6 border-t border-gray-100">
                                <dl className="divide-y divide-gray-100">
                                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-bold leading-6 text-gray-900">
                                            Forfait
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                            {souscription?.donnee?.forfait?.designation ?? '--'}
                                        </dd>
                                    </div>

                                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-bold leading-6 text-gray-900">
                                            Categorie
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-gray-900 sm:col-span-2 sm:mt-0">
                                            {souscription?.donnee?.forfait?.categorie?.replace('_', "").toLowerCase() ?? "--"}
                                        </dd>
                                    </div>

                                    <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-bold leading-6 text-gray-900">
                                            OfferId
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-gray-900 sm:col-span-2 sm:mt-0">
                                            {souscription?.donnee?.forfait?.offerId ?? "--"}
                                        </dd>
                                    </div>

                                </dl>
                            </div>
                        </div>
                        : <div className='w-full my-4 flex items-center justify-center'>
                            <TailSpin
                                height="40"
                                width="40"
                                color="#000"
                                ariaLabel="tail-spin-loading"
                                radius="2"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={loading}
                            />
                        </div>

            }

            {
                error && isPostPaid === false ? (
                    <p className='my-3 text-sm text-red-600'>
                        {error?.donnee}
                    </p>
                ) : null
            }


            <div className="w-full mt-4">
                <hr />
                <div
                    className="flex mt-4"
                    sx={{ display: "flex", flexDirection: "row", pt: 2 }}
                >
                    <Box sx={{ flex: "1 1 auto" }} />
                    <span
                        disabled={!souscription && isPostPaid === false ? true : isPostPaid === true ? false : false}
                        className={`bg-[#ffcb05] btn btn-sm py-1 px-2 font-medium rounded-lg `}
                        onClick={handleNext}
                    >
                        Poursuivre
                    </span>
                </div>
            </div>

        </>
    )
}
